import React, { createContext, useState, useEffect } from 'react';
import userService from '../services/userService';
import teamService from '../services/teamService';
import authService from "../services/authService";
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

export const AuthContext = createContext();

const fetchUser = async (setIsLoggedIn, setRole, setUserName, setUserId, setLoading) => {
	try {
		const res = await userService.getCurrentUser();
		setIsLoggedIn(true);
		setRole(res.role);
		setUserName(res.userName);
		setUserId(res.userId);
	} catch (err) {
		setIsLoggedIn(false);
		setRole(null);
		setUserName(null);
		setUserId(null);
	} finally {
		setLoading(false); // Set loading to false once the fetch is complete
	}
};

export const AuthProvider = ({ children }) => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [role, setRole] = useState(null);
	const [userName, setUserName] = useState(null);
	const [userId, setUserId] = useState(null);
	const [loading, setLoading] = useState(true); // Initialize loading to true
    const { t } = useTranslation();

	useEffect(() => {
		fetchUser(setIsLoggedIn, setRole, setUserName, setUserId, setLoading);
	}, []);

	const login = async () => {
		setLoading(true); // Set loading to true before re-fetching after login
		await fetchUser(setIsLoggedIn, setRole, setUserName, setUserId, setLoading);
	};

	const logout = async () => {
        try {
            await authService.logout();
        } catch (error) {
            console.error('Logout server call failed:', error);
        } finally {
            clearLocalAuthState();
        }
        
        return true;
    };

	const clearLocalAuthState = () => {
        setIsLoggedIn(false);
        setRole(null);
        setUserName(null);
        setUserId(null);
        teamService.clearBadgeCache();
        localStorage.removeItem('pendingInvite');
    };

	const forceLogout = () => {
        clearLocalAuthState();
        window.location.href = '/login';
    };

	return (
        <AuthContext.Provider value={{ 
            isLoggedIn, 
            login, 
            logout, 
            forceLogout,
            role, 
            userName, 
            loading, 
            userId 
        }}>
            {children}
        </AuthContext.Provider>
    );
};